import { useEffect, useRef, useState } from 'react';

interface Ripple {
    x: number;
    y: number;
    timestamp: number;
    id: number;
}

const RippleEffect = () => {
    const [ripples, setRipples] = useState<Ripple[]>([]);
    const nextIdRef = useRef(0);

    useEffect(() => {
        const handleClick = (e: MouseEvent) => {
            const newRipple: Ripple = {
                x: e.clientX,
                y: e.clientY,
                timestamp: Date.now(),
                id: nextIdRef.current++
            };
            
            setRipples(prev => [...prev, newRipple]);
            
            // Remove ripple after animation completes
            setTimeout(() => {
                setRipples(prev => prev.filter(r => r.id !== newRipple.id));
            }, 2000);
        };

        window.addEventListener('click', handleClick);
        
        return () => {
            window.removeEventListener('click', handleClick);
        };
    }, []);

    return (
        <div className="fixed inset-0 pointer-events-none" style={{ zIndex: 3 }}>
            {ripples.map(ripple => (
                <div
                    key={ripple.id}
                    className="ripple-animation"
                    style={{
                        position: 'absolute',
                        left: ripple.x,
                        top: ripple.y,
                        width: '20px',
                        height: '20px',
                        transform: 'translate(-50%, -50%)',
                        pointerEvents: 'none'
                    }}
                >
                    {/* Multiple ripple layers for depth */}
                    <div 
                        className="ripple-circle"
                        style={{
                            background: 'radial-gradient(circle, rgba(255, 182, 193, 0.6) 0%, transparent 70%)',
                            animationDelay: '0s'
                        }}
                    />
                    <div 
                        className="ripple-circle"
                        style={{
                            background: 'radial-gradient(circle, rgba(212, 175, 55, 0.5) 0%, transparent 70%)',
                            animationDelay: '0.1s'
                        }}
                    />
                    <div 
                        className="ripple-circle"
                        style={{
                            background: 'radial-gradient(circle, rgba(221, 160, 221, 0.4) 0%, transparent 70%)',
                            animationDelay: '0.2s'
                        }}
                    />
                    
                    {/* Heart particles burst */}
                    {[...Array(8)].map((_, i) => (
                        <div
                            key={i}
                            className="ripple-heart-particle"
                            style={{
                                position: 'absolute',
                                left: '50%',
                                top: '50%',
                                fontSize: '12px',
                                animationDelay: `${i * 0.05}s`,
                                transform: `rotate(${i * 45}deg) translateY(-30px)`,
                            }}
                        >
                            {i % 2 === 0 ? '✨' : '💕'}
                        </div>
                    ))}
                </div>
            ))}
        </div>
    );
};

export default RippleEffect;
